import { render, staticRenderFns } from "./CredentialTypeSave.vue?vue&type=template&id=1c0ab1eb&scoped=true&"
import script from "./CredentialTypeSave.vue?vue&type=script&lang=js&"
export * from "./CredentialTypeSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ab1eb",
  null
  
)

export default component.exports